import React from 'react';
import { useNavigate } from 'react-router-dom';
import { currencyUSD } from '../../../helpers/forms/formater';

const Columns = () => {
    const navigate = useNavigate();

    return [
        {
            id: 'id',
            name: 'SALE #',
            selector: row => row.id,
            sortable: true,
        },
        {
            id: 'description',
            name: 'DESCRIPTION',
            selector: row => row.description || 'Sale record',
            grow: 1.7,
        },
        {
            id: 'name',
            name: 'CONTACT',
            selector: row => row.client?.contact_name || '—',
        },
        {
            id: 'company',
            name: 'COMPANY',
            selector: row => row.client?.name || '—',
        },
        {
            id: 'payment_date',
            name: 'SALE DATE',
            selector: row => row.created_at,
            sortable: true,
        },
        {
            id: 'total',
            name: 'TOTAL SALE',
            selector: row => currencyUSD(row.total || 0),
            right: true,
        },
        {
            id: 'status',
            name: 'STATUS',
            cell: row => {
                const isCompleted = row.status?.name === 'Completed';

                return (
                    <span
                        className={`px-2 py-1 rounded-full text-white text-xs font-semibold ${
                            isCompleted ? 'bg-green-500' : 'bg-amber-500'
                        }`}
                    >
                        {row.status?.name || 'Pending'}
                    </span>
                );
            },
        },
        {
            id: 'actions',
            name: '',
            cell: row => (
                <div className="flex items-center">
                    <button
                        onClick={() => navigate(`/payment-details/${row.id}`)}
                        className="px-3 py-2 hover:bg-gray-100"
                        title="View sale details"
                        type="button"
                    >
                        <i className="fas fa-eye text-mts-blue-primary"></i>
                    </button>
                </div>
            ),
            width: '90px',
        }
    ];
};

export default Columns;
